<template>
	<el-time-picker
		:size="size"
		is-range
		rage-separator="-"
		format="HH:mm"
		disabled-seconds
		:clearable="true"
		popper-class="time-only-range-picker"
		start-placeholder="Начало работ"
		end-placeholder="Окончание работ"
		v-model="timePikerModel"
		@change="onTimePicked">
	</el-time-picker>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Memo } from '@element-plus/icons-vue';
import timeOnlyHelper from '@/helpers/timeOnlyHelper';
import { watch, WatchStopHandle } from 'vue';

@Options({	
	components: {
		Memo
	},
	props: {
		startTime: String,
		endTime: String,
		size: {
			type: String,
			default: 'default'
		}
	},
	emits: ['update:startTime', 'update:endTime', 'changed']
})
export default class TimeOnlyRangePickerComponent extends Vue {
	/** props */
	startTime!: string;
	endTime!: string;
	size!: string;
	
	/** view-models */
	timePikerModel: Array<Date> = [new Date(), new Date()];

	startTimeWatchSubscription?: WatchStopHandle;
	endTimeWatchSubscription?: WatchStopHandle;

	mounted() {
		this.startTimeWatchSubscription = watch(
			() => this.startTime,
			(startTime: string) => {
				if (!startTime) {
					this.timePikerModel[0] = new Date();
					return;
				}				
				this.timePikerModel[0] = this.mapTimeOnlyToDate(startTime);
			});

		this.endTimeWatchSubscription = watch(
			() => this.endTime,
			(endTime: string) => {
				if (!endTime) {
					this.timePikerModel[1] = new Date();
					return;
				}

				this.timePikerModel[0] = this.mapTimeOnlyToDate(endTime);
			});


		if (this.startTime) {
			this.timePikerModel[0] = this.mapTimeOnlyToDate(this.startTime);
		}

		if (this.endTime) {
			this.timePikerModel[0] = this.mapTimeOnlyToDate(this.endTime);
		}
	}

	unmounted(): void {
		if (this.startTimeWatchSubscription) {
			this.startTimeWatchSubscription();
		}

		if (this.endTimeWatchSubscription) {
			this.endTimeWatchSubscription();
		}
	}

	onTimePicked(v: Array<Date>) {
		let startTimeOnly = timeOnlyHelper.time(v[0]);
		let endTimeOnly = timeOnlyHelper.time(v[1]);
		
		this.$emit('update:startTime', startTimeOnly);
		this.$emit('update:endTime', endTimeOnly);

		this.$nextTick()
			.then(() => this.$emit('changed', [startTimeOnly, endTimeOnly]));
	}

	mapTimeOnlyToDate(time: string) {
		const [hours, minutes] = time.split(':').map(Number);
		const d = new Date();
		d.setHours(hours as number);
		d.setMinutes(minutes as number);

		return d;
	}
}
</script>

<style>
	.time-only-range-picker {

	}

		.time-only-range-picker .el-time-range-picker__header {
			display: none!important;
		}
</style>
